var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.lignes.length)?_c('v-client-table',{staticClass:"displayNonePagination",attrs:{"data":_vm.lignes,"columns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"produit",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.libelle)+" ")]}},{key:"quantite",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"is-pulled-right"},[_vm._v(" "+_vm._s(row.quantite)+" ")])]}},{key:"quantiteReceptionnee",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"is-pulled-right"},[_vm._v(" "+_vm._s(row.quantite - row.quantiteResteARapprocher)+" ")])]}},{key:"solde",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"is-pulled-right"},[_vm._v(" "+_vm._s(row.quantiteResteARapprocher)+" ")])]}}],null,false,3950228016)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }